import {
  ALL_CANDI_REQUEST_REQUEST,
  ALL_CANDI_REQUEST_SUCCESS,
  ALL_CANDI_REQUEST_FAIL,
} from "../constants/AuthConstant";

const axios = require("axios");

/* -------------------- Helper -------------------- */
const buildQueryParam = (key, values = []) => {
  if (!values || values.length === 0) return "";
  return `&${key}=${values.map(encodeURIComponent).join(",")}`;
};

/* -------------------- Action -------------------- */
export const AllCandidateL = (data) => {
  return function (dispatch) {
    dispatch({
      type: ALL_CANDI_REQUEST_REQUEST,
      payload: true,
    });

    const {
      vendorId,
      pageNumber,
      search = "",
      encodedData = [],
      citySendApi = [],
      stateSendApi = [],
      countrySendApi = [],
      designationSendapi = [],
      min = "",
      max = "",
    } = data;

    const baseUrl = `${process.env.REACT_APP_API_PATH}/ebench/get_all_candidate_v3`;

    const url =
      `${baseUrl}?vendorId=${vendorId}` +
      `&pageNumber=${pageNumber}` +
      `&pageSize=10` +
      `&search=${encodeURIComponent(search)}` +
      buildQueryParam("skills", encodedData) +
      buildQueryParam("city", citySendApi) +
      buildQueryParam("state", stateSendApi) +
      buildQueryParam("country", countrySendApi) +
      buildQueryParam("currentDesignations", designationSendapi) +
      `&minExperience=${min}` +
      `&maxExperience=${max}`;

    axios({
      url,
      method: "GET",
      headers: {
        "content-type": "application/json",
      },
    })
      .then((res) => {
        dispatch(loadAllDetailsPre(res.data));
      })
      .catch((error) => {
        dispatch({
          type: ALL_CANDI_REQUEST_FAIL,
          payload: false,
          error,
          msg: "Failed to load the information",
        });
      });
  };
};

/* -------------------- Success -------------------- */
export const loadAllDetailsPre = (data) => {
  return {
    type: ALL_CANDI_REQUEST_SUCCESS,
    result: data,
    payload: false,
    msg: "SUCCESS",
  };
};
